import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, module: requiredModule }) {
  const { user, loading, can } = useAuth();
  const loc = useLocation();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-muted-foreground text-sm" data-testid="loading-indicator">Loading…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  }
  if (requiredModule && !can(requiredModule)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background p-8">
        <div className="max-w-md text-center" data-testid="access-denied">
          <p className="label-tiny mb-2">Access denied</p>
          <h2 className="text-2xl mb-2">You don't have access to this module.</h2>
          <p className="text-muted-foreground text-sm">
            Ask your Owner to grant <span className="font-mono">{requiredModule}</span> access.
          </p>
        </div>
      </div>
    );
  }
  return children;
}
